<template>
  <v-autocomplete
    ref="nationalityRef"
    :items="nationalities"
    @input="input"
    hide-no-data
    item-text="nationality"
    item-value="nationality"
    dense
    outlined
    placeholder="Start typing to search nationalities"
    label="Nationality"
    autocomplete="off"
    :value="value"
    v-on="listeners"
    v-bind="attrs"
  >
    <template v-slot:label>
      {{attrs.label || 'Nationality'}}
      <span v-if="required" class="red--text">*</span>
    </template>
  </v-autocomplete>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'NationalityPicker',

  props: {
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapGetters('coreModule', ['nationalities']),

    listeners() {
      const { ...listeners } = this.$listeners;
      return listeners;
    },
    attrs() {
      const { ...attrs } = this.$attrs;
      return attrs;
    }
  },

  methods: {
    input(event) {
      this.$emit('input', event);
    },

    blur(event) {
      this.$emit('blur', event);
    }
  }
};
</script>
